import { supabase } from '@/api/adapters/supabase/shared'
import { parseAppearance } from '@/features/appearance/preferences'
import type { AppearancePreferences } from '@/types/preferences'

export async function getAppearancePreferences(userId: string): Promise<AppearancePreferences | null> {
  const { data, error } = await supabase.from('user_preferences').select('appearance').eq('user_id', userId).maybeSingle()
  if (error) throw error
  return data ? parseAppearance(data.appearance) : null
}
export async function saveAppearancePreferences(userId: string, appearance: AppearancePreferences): Promise<AppearancePreferences> {
  const { data, error } = await supabase.from('user_preferences')
    .upsert({ user_id: userId, appearance: parseAppearance(appearance) }, { onConflict: 'user_id' })
    .select('appearance').single()
  if (error) throw error
  return parseAppearance(data.appearance)
}
